<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			type: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '导入任务',
				modal_width: 800,
				modal_height: 500,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						field: 'filename',
						title: '文件名称',
					},
					{
						field: 'count',
						title: '总数据'
					},
					// {
					// 	field: 'remaincount',
					// 	title: '未处理数据'
					// },
					// {
					// 	field: 'type',
					// 	title: '类型'
					// },
					{
						field: 'progress',
						title: '进度',
						formatter({row}){
							return ((row.count - row.remaincount)/row.count * 100).toFixed(2) + '%'
						}
					},
					{
						field: 'status',
						title: '状态',
						formatter({cellValue}){
							if(cellValue == 0){
								return '进行中'
							}
							if(cellValue == 1){
								return '已完成'
							}
							if(cellValue == 2){
								return '失败'
							}
						}
					},
					{
						field: 'error',
						title: '错误'
					},
					{
						field: 'staffid',
						title: '创建人',
						formatter({cellValue}){
							return window.systemMethods.getstaff(cellValue)
						}
					},
					{
						field: 'create_time',
						title: '创建时间',
						formatter({cellValue}){
							return window.systemMethods.timestampToDate(cellValue)
						}
					},
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {

					this.$api.importtask.list({
						type: this.type
					}).then((res) => {
						resolve(res)
					})
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)

				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>